import React from "react";
import moment from "moment";
import { Container } from "react-bootstrap";
import { IconAlertError } from "../../utils/icons";
import Button from "../button/Button";
import "./ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error, info) {
    // console.log is no-op'd in PROD (see index.js); console.error is preserved.
    console.error("Uncaught render error:", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      const currentYear = moment().format("YYYY");
      return (
        <div className="login-container">
          <Container>
            <div className="forgot-password-form-body text-center">
              <div className="login-messagesV2 text-center">
                <div>
                  <h2 className="password-changed-title">Something went wrong</h2>
                  <p className="account-blocked-text mb-0">
                    An unexpected error occurred while displaying this page. You can try again or go back to the homepage.
                  </p>
                </div>
                <div className="error-boundary-icon">
                  <IconAlertError />
                </div>
                <div className="error-boundary-actions">
                  <Button onClick={this.handleReset} className="secondary btn_login">
                    Try again
                  </Button>
                  <Button
                    onClick={() => (window.location.href = "/transaction-list")}
                    className="primary btn_login"
                  >
                    Back to Home
                  </Button>
                </div>
              </div>
            </div>
          </Container>
          <div>
            <p className="copyright-text">
              Copyright © {currentYear} {process.env.REACT_APP_TITLE}
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
